import { render, staticRenderFns } from "./TourContainer.vue?vue&type=template&id=3cff182e&scoped=true&"
import script from "./TourContainer.vue?vue&type=script&lang=js&"
export * from "./TourContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cff182e",
  null
  
)

export default component.exports